export { default } from "./src/index";
export type { UniformHeroSectionProps } from "./src/index";
